import {
  SET_USER_INFO,
  USERINFO_STATUS,
  SET_USER_BEHAVIOR_TABLE,
  SET_CT_USER_INFO,
} from '../constants/ActionTypes.js';

export const setUserInfo = data => ({
  type: SET_USER_INFO,
  data,
});

export const setCTUserInfo = data => ({
  type: SET_CT_USER_INFO,
  data,
});

export const clearUserInfo = data => ({
  type: USERINFO_STATUS,
  data,
});

export const setUserBehaviorTable = data => ({
  type: SET_USER_BEHAVIOR_TABLE,
  data,
});
